import { createProvideInject } from '@collector/shared-ui'
import type { SportsApiClient } from '@collector/sportsapi-client'

export const [provideSportsApiClient, injectSportsApiClient]: [
  (client: SportsApiClient) => void,
  () => SportsApiClient,
] = createProvideInject<SportsApiClient>('SportsApiClient')
